import { Modal, Button } from 'react-bootstrap'

import { Condition } from '../../utils/Data'
import colors from '../../utils/styles/Colors'

const ConsentModal = ({
  isVisible,
  onClose = () => {},
  onConfirm = () => {},
}) => {
  return (
    <Modal scrollable centered show={isVisible} onHide={onClose}>
      <Modal.Header closeButton>
        <Modal.Title style={{ color: colors.black }}>
          เงื่อนไขการใช้บริการ
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Condition />
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={onClose}>ปิด</Button>
      </Modal.Footer>
    </Modal>
  )
}

export default ConsentModal
